"use client";

import React from "react";

const WhyChooseSmile4Me: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Why Choose Us For Night Guards?
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        When it comes to protecting your oral health, you deserve the best. At Smile4Me, we are committed to providing our patients with top-quality dental services, including custom night guards tailored to their individual needs. Our experienced team of dental professionals takes the time to understand each patient&apos;s unique situation and creates a personalized treatment plan to address their specific concerns.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        In addition to our commitment to exceptional care, we also utilize state-of-the-art technology in our practice. This allows us to create precise, comfortable, and durable night guards that provide superior protection against bruxism-related damage. Our advanced digital scanning technology ensures an accurate fit, while our high-quality materials ensure the longevity of your custom night guard.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Furthermore, we understand that cost can be a concern when it comes to dental care. That&apos;s why we offer flexible payment plans and accept various insurance providers to make our services more accessible. We believe that everyone deserves a healthy, confident smile, and we&apos;re here to help you achieve it.
      </p>
    </div>
  );
};

export default WhyChooseSmile4Me;